function toCurrency(value){
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });
  return formatter.format(parseFloat(value));
}
function capitalizeWords (value){
  let str = value.toLowerCase();
  return str.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
}
export {toCurrency, capitalizeWords}